import React from 'react';
import { useStore } from '../store';
import { useShallow } from 'zustand/react/shallow';
import { Alert, AlertDescription } from '@roger/ui-components';
import { AlertTriangle } from 'lucide-react';
import {
  AgencyManagementSection,
  ArchetypeRolesSection,
  GoalSyncSection,
  TestPatientCleanupSection,
} from '../components/admin';
import { PermissionSlug } from '../constants/featureFlags';

const InternalAdmin: React.FC = () => {
  const { hasPermission } = useStore(
    useShallow(state => ({
      hasPermission: state.hasPermission,
    }))
  );

  // Permission check
  if (!hasPermission('emr:manage')) {
    return (
      <div>
        <Alert className='border-red-200 bg-red-50'>
          <AlertDescription className='text-red-800 flex gap-2 items-center'>
            <AlertTriangle className='h-4 w-4 text-red-600' />
            You don't have permission to access Internal Admin features. Please
            contact your administrator if you need access.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className='space-y-6'>
      <div className='grid gap-6'>
        {/* Saving the agency needs admin:super-user, so others see it read-only */}
        <AgencyManagementSection
          mode={
            hasPermission(PermissionSlug.ADMIN_SUPER_USER)
              ? 'editable'
              : 'readonly'
          }
        />
        <GoalSyncSection />
        <ArchetypeRolesSection />
        <TestPatientCleanupSection />
      </div>
    </div>
  );
};

export default InternalAdmin;
